import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { LANDING_PATH } from '../App';
import { X } from 'lucide-react';

const ReturnAndRefundPolicy = () => {
    const navigate = useNavigate();
    const handleBack = () => {
        if (window.history.state && window.history.state.idx > 0) {
            navigate(-1);
        } else {
            navigate(LANDING_PATH, { replace: true });
        }
    };
    return (
        <div className="page-size p-4 md:p-8 relative">
            <button
                className="fixed top-4 right-4 btn btn-outline btn-square btn-sm"
                onClick={handleBack}
            >
                <X />
            </button>
            <h1 className="text-3xl font-bold mb-4">Return & Refund Policy</h1>
            <div className="prose max-w-none">
                <p>Malaysia Fight League (MFL) is committed to providing a fair and transparent process regarding refunds and returns for all our participants and customers. Please read the following policy carefully before registering for an event or purchasing a pay-per-view (PPV) stream.</p>
                <h3>1. Athlete Registration</h3>
                <h4>Opponent Matching</h4>
                <ul>
                    <li>Once your registration is confirmed, our team will begin the process of finding you a suitable opponent based on your weight, skill level, and experience.</li>
                    <li>If we are unable to match you with an opponent, you may choose between:
                        <ul>
                            <li>A full refund, processed within 10 working days after the event date, or</li>
                            <li>A carry-forward credit for a future event.</li>
                        </ul>
                    </li>
                </ul>
                <h4>Carry-Forward Credit Terms</h4>
                <ul>
                    <li>Credit can be held for up to two consecutive MFL events only.</li>
                    <li>If an opponent is found for the next event and you decline the match, you will have one more opportunity to compete.</li>
                    <li>If you decline again or remain unmatched, the credit will be voided and non-refundable.</li>
                </ul>
                <h4>Withdrawals & Cancellations</h4>
                <ul>
                    <li>Withdrawals due to injury, personal reasons, or other unforeseen circumstances are non-refundable.</li>
                    <li>You may not transfer your registration or event credit to another person.</li>
                </ul>
                <h4>Payment Errors & Responsibility</h4>
                <ul>
                    <li>MFL is not liable for incorrect transactions, including:
                        <ul>
                            <li>Wrong payment amounts</li>
                            <li>Transfers to incorrect accounts</li>
                            <li>Duplicate payments</li>
                        </ul>
                    </li>
                    <li>We do not accept refund requests arising from participant negligence.</li>
                </ul>
                <h4>Disclaimer</h4>
                <ul>
                    <li>Combat sports carry a risk of injury. By registering, you acknowledge and accept that MFL will not be held responsible for any injuries sustained before, during, or after the event.</li>
                </ul>
                <h3>2. Pay-Per-View (PPV) Live Purchase</h3>
                <h4>Final Sale Policy</h4>
                <ul>
                    <li>All PPV purchases are final and non-refundable.</li>
                    <li>Refunds will only be granted if the fault lies with MFL, including but not limited to:
                        <ul>
                            <li>Major streaming failures</li>
                            <li>Unforeseen technical crashes caused by our system</li>
                        </ul>
                    </li>
                </ul>
                <h4>Device Limitation</h4>
                <ul>
                    <li>Each PPV ticket is valid for one device only.</li>
                    <li>Simultaneous viewing on multiple devices is not supported and may result in restricted access.</li>
                </ul>
                <h4>Event-Specific Access</h4>
                <ul>
                    <li>PPV access is strictly limited to the specific event purchased.</li>
                    <li>Access cannot be transferred to future or past events.</li>
                </ul>
                <h4>Technical Requirements</h4>
                <ul>
                    <li>It is the buyer's responsibility to ensure they have:
                        <ul>
                            <li>A stable internet connection</li>
                            <li>A compatible device</li>
                            <li>Access during the event time</li>
                        </ul>
                    </li>
                    <li>MFL will not be responsible for technical issues on the buyer's end (e.g., poor internet, outdated browser, device malfunction).</li>
                </ul>
                <p>For any questions regarding refunds or to submit a refund request (when eligible), please contact us at:<br />
                    <b>info@malaysiafightleague.com</b><br />
                    <b>+60 10-983 1808</b></p>
                <p>Thank you for your understanding and continued support of Malaysia Fight League.</p>
            </div>
        </div>
    );
};

export default ReturnAndRefundPolicy;
